import { render, staticRenderFns } from "./RouteTagInput.vue?vue&type=template&id=0ff7e959&"
import script from "./RouteTagInput.vue?vue&type=script&lang=js&"
export * from "./RouteTagInput.vue?vue&type=script&lang=js&"
import style0 from "./RouteTagInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports